/*
  L'affido. Nessuna libreria, nessun drawer, nessun movimento.

  Tre compiti:
  1. al cambio di forma aggiorna prezzo, disponibilita', bottone e indirizzo;
  2. all'invio manda il corpo all'affido senza ricaricare; se c'e' un testo
     da incidere senza la presa d'atto, ferma tutto e mostra la riga; poi
     scopre la conferma in pagina e aggiorna il conteggio nella testa;
  3. tiene la barra del telefono in vista soltanto mentre il bottone vero e'
     sopra lo schermo, e la toglie quando compare il piede.

  Se la richiesta non riesce, il form parte come partirebbe senza JavaScript.
  Ogni testo visibile arriva dal Liquid: qui dentro non si scrive una parola.

  Dal 5 ottobre 2026 anche: la finestra della scatola di legno, che si apre
  come quella dei dettagli; e il regalo all'invio, che senza il nome di chi
  lo riceve non parte, mentre con il nome lascia a terra solo i campi vuoti e
  compare nella finestra del carrello. La finestra del regalo sta in
  regalo.js.

  E il filo di ritorno: al caricamento la scheda annota il monile in
  sessionStorage, alla chiave daymonilia-monile, nella forma
  {"v":1,"nome":"Manto","url":"/products/manto"}. Le pagine della Casa la
  leggono (assets/casa.js) e sotto il Prosegui scrivono "Torna a Manto".
  Nome e indirizzo vengono dal Liquid, sulla radice della scheda. Se la
  memoria del browser manca o e' chiusa, non si annota niente e niente si
  rompe.
*/

(function () {
  'use strict';

  function misura(nome, dettaglio) {
    if (!window.Daymonilia || typeof window.Daymonilia.misura !== 'function') return;
    try {
      window.Daymonilia.misura(nome, dettaglio);
    } catch (errore) {
      /* La misura non ferma mai l'affido. */
    }
  }

  function annuncia(numero) {
    var evento;
    try {
      evento = new CustomEvent('cartcount', { detail: numero });
    } catch (errore) {
      evento = document.createEvent('CustomEvent');
      evento.initCustomEvent('cartcount', false, false, numero);
    }
    document.dispatchEvent(evento);
  }

  function conteggio(numero, modello) {
    var elementi = document.querySelectorAll('[data-conteggio-affido]');
    for (var i = 0; i < elementi.length; i++) {
      elementi[i].textContent = modello.replace('@n', String(numero));
    }
    annuncia(numero);
  }

  /* La stessa regola del frammento cifra: in italiano la cifra poi il simbolo, in inglese il simbolo poi la cifra. */
  function gruppi(intero, separatore) {
    var testo = String(intero);
    var fuori = '';
    while (testo.length > 3) {
      fuori = separatore + testo.slice(-3) + fuori;
      testo = testo.slice(0, -3);
    }
    return testo + fuori;
  }

  function formatta(centesimi, formato, simbolo) {
    var totale = Math.round(Number(centesimi));
    if (isNaN(totale)) return '';
    var intero = Math.floor(totale / 100);
    var resto = String(totale % 100);
    if (resto.length < 2) resto = '0' + resto;
    /* I prezzi della Casa sono interi: i centesimi si scrivono solo se ci sono. */
    if (formato === 'it') return gruppi(intero, '.') + (resto === '00' ? '' : ',' + resto) + ' ' + simbolo;
    return simbolo + gruppi(intero, ',') + (resto === '00' ? '' : '.' + resto);
  }

  function leggiMappa(form) {
    var deposito = form.querySelector('[data-affido-mappa]');
    if (!deposito) return null;
    try {
      return JSON.parse(deposito.textContent);
    } catch (errore) {
      return null;
    }
  }

  function aggiornaIndirizzo(url) {
    if (!url || !window.history || !window.history.replaceState) return;
    window.history.replaceState({}, '', url);
  }

  function scriviPrezzo(form, centesimi) {
    if (centesimi === null || centesimi === undefined || centesimi === '') return;
    var testo = formatta(centesimi, form.getAttribute('data-formato') || 'en', form.getAttribute('data-simbolo') || '');
    if (!testo) return;
    var punti = document.querySelectorAll('[data-affido-prezzo], [data-affido-prezzo-barra]');
    for (var i = 0; i < punti.length; i++) {
      punti[i].textContent = testo;
      if (punti[i].hasAttribute('data-cents')) punti[i].setAttribute('data-cents', String(centesimi));
    }
  }

  function scriviBottone(form, disponibile) {
    var bottone = form.querySelector('[data-affido-invio]');
    if (!bottone) return;
    bottone.disabled = !disponibile;
    var testo = bottone.querySelector('[data-affido-invio-testo]');
    var parola = bottone.getAttribute(disponibile ? 'data-testo-affida' : 'data-testo-non-disponibile');
    if (testo && parola) testo.textContent = parola;
    /* La regione viva: chi ascolta sa se la forma scelta si puo' ancora affidare. */
    var voce = form.querySelector('[data-affido-voce]');
    if (voce && parola) voce.textContent = parola;
  }

  /* Le quattro proprieta' del regalo, con le chiavi fisse scritte nel Liquid. */
  var PROPRIETA_REGALO = [
    'properties[Regalo per]',
    'properties[Dedica]',
    'properties[Senza prezzo]',
    'properties[_regalo]'
  ];

  function pulito(testo) {
    return String(testo || '').replace(/^\s+|\s+$/g, '');
  }

  /* Senza il nome non c'e' regalo e non parte niente; con il nome restano a terra solo i campi vuoti. */
  function togliRegaloVuoto(dati, nome) {
    if (typeof dati['delete'] !== 'function') return;
    var leggibile = typeof dati.get === 'function';
    for (var r = 0; r < PROPRIETA_REGALO.length; r++) {
      var chiave = PROPRIETA_REGALO[r];
      if (!nome || (leggibile && !pulito(dati.get(chiave)))) dati['delete'](chiave);
    }
  }

  /* La finestra del carrello: la forma scelta, l'incisione, il regalo, il prezzo di adesso. */
  function apriFinestra(form, finestra, incisione, regalo) {
    if (!finestra || typeof finestra.showModal !== 'function') return;
    var variante = finestra.querySelector('[data-carrello-variante]');
    var riga = finestra.querySelector('[data-carrello-incisione]');
    var rigaRegalo = finestra.querySelector('[data-carrello-regalo]');
    var prezzo = finestra.querySelector('[data-carrello-prezzo]');
    /* La forma scelta si legge dall'etichetta del radio, non dal valore: con
       una sola opzione il valore è l'id della variante, un numero. */
    var scelte = [];
    var fotoVariante = '';
    var radio = form.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radio.length; i++) {
      var etichetta = radio[i].id ? form.querySelector('label[for="' + radio[i].id + '"]') : null;
      var nome = etichetta ? etichetta.textContent.replace(/^\s+|\s+$/g, '') : '';
      if (!nome && !/^\d+$/.test(radio[i].value)) nome = radio[i].value;
      if (nome) scelte.push(nome);
      if (radio[i].getAttribute('data-affido-foto')) fotoVariante = radio[i].getAttribute('data-affido-foto');
    }
    var foto = finestra.querySelector('.carrello-modale__foto');
    if (foto && fotoVariante) {
      foto.removeAttribute('srcset');
      foto.src = fotoVariante;
    }
    if (variante) {
      variante.textContent = scelte.join(' · ');
      variante.hidden = !scelte.length;
    }
    if (riga) {
      var modello = riga.getAttribute('data-modello') || '@t';
      riga.textContent = incisione ? modello.replace('@t', '«' + incisione + '»') : '';
      riga.hidden = !incisione;
    }
    if (rigaRegalo) {
      var modelloRegalo = rigaRegalo.getAttribute('data-modello') || '@t';
      /* Il nome entra con una funzione: un $ scritto dal custode resta un $. */
      rigaRegalo.textContent = regalo ? modelloRegalo.replace('@t', function () { return regalo; }) : '';
      rigaRegalo.hidden = !regalo;
    }
    var adesso = form.querySelector('[data-affido-prezzo]');
    if (prezzo && adesso) prezzo.textContent = adesso.textContent;
    finestra.showModal();
    var chiudi = finestra.querySelector('[data-carrello-chiudi]');
    if (chiudi) chiudi.focus();
  }

  /* Le finestre si chiudono con garbo (6 ottobre 2026): close() aspetta la fine
     dell'animazione di uscita (classe in-chiusura), ed Esc passa dallo stesso
     close(). Con meno movimento si chiudono subito, come prima. */
  function chiusureGentili() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var finestre = document.querySelectorAll('dialog.dettagli-modale, dialog.carrello-modale, dialog.incisione-modale, dialog.regalo-modale');
    Array.prototype.forEach.call(finestre, function (finestra) {
      if (finestra.chiudiSubito) return;
      var chiudiSubito = HTMLDialogElement.prototype.close.bind(finestra);
      finestra.chiudiSubito = chiudiSubito;
      finestra.close = function (valore) {
        if (!finestra.open || finestra.classList.contains('in-chiusura')) return;
        finestra.classList.add('in-chiusura');
        var fatto = false;
        function fine() {
          if (fatto) return;
          fatto = true;
          finestra.removeEventListener('animationend', suFine);
          finestra.classList.remove('in-chiusura');
          if (valore === undefined) chiudiSubito(); else chiudiSubito(valore);
        }
        function suFine(evento) {
          if (evento.target === finestra) fine();
        }
        finestra.addEventListener('animationend', suFine);
        window.setTimeout(fine, 340);
      };
      finestra.addEventListener('cancel', function (evento) {
        evento.preventDefault();
        finestra.close();
      });
    });
  }

  function preparaFinestra() {
    var finestra = document.querySelector('[data-carrello-modale]');
    if (!finestra) return;
    var chiudi = finestra.querySelector('[data-carrello-chiudi]');
    if (chiudi) chiudi.addEventListener('click', function () { finestra.close(); });
    finestra.addEventListener('click', function (evento) {
      if (evento.target === finestra) finestra.close();
    });
  }

  /*
    Le finestre che entrano da destra: i dettagli del monile, dalla voce
    Dettagli, e dal 5 ottobre 2026 la scatola di legno, dalla fila dei
    servizi. Stesso contratto per tutte e due: data-<nome>-apri,
    data-<nome>-modale, data-<nome>-chiudi; la misura <nome>_apri; alla
    chiusura il fuoco torna alla voce che l'ha aperta.
  */
  function preparaPannello(nome) {
    var finestra = document.querySelector('[data-' + nome + '-modale]');
    if (!finestra || typeof finestra.showModal !== 'function') return;
    var daRimettere = null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-' + nome + '-apri]'), function (bottone) {
      bottone.addEventListener('click', function () {
        daRimettere = bottone;
        finestra.showModal();
        misura(nome + '_apri');
      });
    });
    var chiudi = finestra.querySelector('[data-' + nome + '-chiudi]');
    if (chiudi) chiudi.addEventListener('click', function () { finestra.close(); });
    finestra.addEventListener('click', function (evento) {
      if (evento.target === finestra) finestra.close();
    });
    finestra.addEventListener('close', function () {
      if (daRimettere) daRimettere.focus();
    });
  }

  function preparaForm(form) {
    var mappa = leggiMappa(form);
    var campoId = form.querySelector('[data-affido-id]');
    var esito = form.querySelector('[data-affido-esito]');
    var finestra = document.querySelector('[data-carrello-modale]');
    var guasto = form.querySelector('[data-affido-guasto]');
    var errore = form.querySelector('[data-incisione-errore]');
    var campoIncisione = form.querySelector('input[name="properties[L\'incisione]"]');
    var campoRegalo = form.querySelector('[data-regalo-per-valore]');
    var reso = form.querySelector('[data-incisione-reso]');
    var urlAggiunta = form.getAttribute('data-url-aggiunta') || '/cart/add';
    var urlCarrello = form.getAttribute('data-url-carrello') || '/cart';
    var modello = form.getAttribute('data-modello-conteggio') || '@n';
    var maniglia = form.getAttribute('data-handle') || '';
    var chiusura = form.querySelector('[data-affido-chiusura]');
    var notaChiusura = form.querySelector('[data-chiusura-nota]');

    /*
       La chiusura degli orecchini (7 ottobre 2026) vale solo per le forme
       che sono orecchini: il fieldset porta i loro identificativi in
       data-varianti, nella forma ",id,id,". Spento (disabled) non manda
       niente all'ordine.
    */
    function aggiornaChiusura(idVariante) {
      if (!chiusura) return;
      var ammesse = chiusura.getAttribute('data-varianti') || '';
      var vale = ammesse.indexOf(',' + idVariante + ',') !== -1;
      chiusura.hidden = !vale;
      chiusura.disabled = !vale;
    }

    function testoIncisione() {
      return campoIncisione ? campoIncisione.value.replace(/^\s+|\s+$/g, '') : '';
    }

    function incisioneSenzaPresa() {
      return !!(campoIncisione && reso && testoIncisione() && !reso.checked);
    }

    function mostraErrore() {
      if (errore) errore.hidden = false;
      if (reso) reso.focus();
    }

    if (reso) {
      /* La presa d'atto e' obbligatoria solo con un testo da incidere: la riga e' la nostra, non quella del browser. */
      reso.addEventListener('invalid', function (evento) {
        evento.preventDefault();
        mostraErrore();
      });
      reso.addEventListener('change', function () {
        if (reso.checked && errore) errore.hidden = true;
      });
    }

    form.addEventListener('change', function (evento) {
      var campo = evento.target;
      if (!campo || campo.type !== 'radio') return;

      if (campo.hasAttribute('data-chiusura-radio')) {
        if (notaChiusura) notaChiusura.textContent = campo.getAttribute('data-nota') || '';
        return;
      }

      if (campo.hasAttribute('data-affido-radio')) {
        scriviPrezzo(form, campo.getAttribute('data-affido-cents'));
        scriviBottone(form, campo.getAttribute('data-affido-disponibile') === '1');
        aggiornaIndirizzo(campo.getAttribute('data-affido-url'));
        aggiornaChiusura(campo.value);
        return;
      }

      if (!campo.hasAttribute('data-affido-opzione') || !mappa || !campoId) return;

      var scelte = [];
      var radio = form.querySelectorAll('[data-affido-opzione]:checked');
      for (var i = 0; i < radio.length; i++) {
        scelte[Number(radio[i].getAttribute('data-affido-opzione'))] = radio[i].value;
      }

      for (var v = 0; v < mappa.length; v++) {
        var pari = true;
        for (var o = 0; o < scelte.length; o++) {
          if (mappa[v].opzioni[o] !== scelte[o]) pari = false;
        }
        if (!pari) continue;
        campoId.value = mappa[v].id;
        scriviPrezzo(form, mappa[v].prezzo);
        scriviBottone(form, mappa[v].disponibile === true);
        aggiornaIndirizzo(mappa[v].url);
        aggiornaChiusura(mappa[v].id);
        return;
      }

      scriviBottone(form, false);
    });

    form.addEventListener('submit', function (evento) {
      if (incisioneSenzaPresa()) {
        evento.preventDefault();
        mostraErrore();
        return;
      }
      if (!window.fetch || !window.FormData) return;
      evento.preventDefault();

      if (guasto) guasto.hidden = true;
      if (esito) esito.hidden = true;
      var bottone = form.querySelector('[data-affido-invio]');
      if (bottone) bottone.disabled = true;

      var dati = new FormData(form);
      var catenaCampo = form.querySelector('input[name="properties[Catena]"]');
      var incisioneTesto = testoIncisione();
      if (!incisioneTesto && typeof dati['delete'] === 'function') {
        dati['delete']("properties[L'incisione]");
      }
      var regaloNome = campoRegalo && !campoRegalo.disabled ? pulito(campoRegalo.value) : '';
      togliRegaloVuoto(dati, regaloNome);

      misura('affida_click', {
        handle: maniglia,
        variante: typeof dati.get === 'function' ? dati.get('id') : null,
        catena: catenaCampo ? catenaCampo.value : null,
        incisione: !!incisioneTesto,
        regalo: !!regaloNome
      });

      var riuscito = false;

      fetch(urlAggiunta + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: dati
      })
        .then(function (risposta) {
          if (!risposta.ok) throw new Error('affido');
          return risposta.json();
        })
        .then(function () {
          riuscito = true;
          if (bottone) bottone.disabled = false;
          apriFinestra(form, finestra, incisioneTesto, regaloNome);
          if (!finestra && esito) {
            esito.hidden = false;
            esito.focus();
          }
          misura('affida_riuscito', { handle: maniglia });
          return fetch(urlCarrello + '.js', { headers: { Accept: 'application/json' } })
            .then(function (risposta) {
              return risposta.ok ? risposta.json() : null;
            })
            .then(function (carrello) {
              if (carrello) conteggio(carrello.item_count, modello);
            })
            .catch(function () {
              /* Il corpo e' in affido: il conteggio si aggiorna alla pagina dopo. */
            });
        })
        .catch(function () {
          if (riuscito) return;
          misura('affida_fallito', { handle: maniglia });
          if (bottone) bottone.disabled = false;
          if (guasto) guasto.hidden = false;
          form.submit();
        });
    });
  }

  /* La barra del telefono: compare quando il bottone vero e' passato sopra, sparisce sul piede. */
  function preparaBarra(form) {
    var barra = document.querySelector('[data-barra-affido]');
    var bottone = form.querySelector('[data-affido-invio]');
    if (!barra || !bottone || !('IntersectionObserver' in window)) return;

    var sopra = false;
    var piedeInVista = false;

    function aggiorna() {
      barra.hidden = !(sopra && !piedeInVista);
    }

    new IntersectionObserver(function (voci) {
      var voce = voci[voci.length - 1];
      sopra = !voce.isIntersecting && voce.boundingClientRect.top < 0;
      aggiorna();
    }).observe(bottone);

    var piede = document.querySelector('footer');
    if (piede) {
      new IntersectionObserver(function (voci) {
        piedeInVista = voci[voci.length - 1].isIntersecting;
        aggiorna();
      }).observe(piede);
    }
  }

  /* Il filo di ritorno: il monile di questa scheda, per le pagine della Casa. */
  function annotaMonile() {
    var radice = document.querySelector('[data-monile-nome]');
    if (!radice) return;
    var nome = pulito(radice.getAttribute('data-monile-nome'));
    var url = radice.getAttribute('data-monile-url') || '';
    if (!nome || url.charAt(0) !== '/') return;
    try {
      window.sessionStorage.setItem('daymonilia-monile', JSON.stringify({ v: 1, nome: nome, url: url }));
    } catch (errore) {
      /* Senza memoria del browser il filo non c'e': la scheda resta com'e'. */
    }
  }

  annotaMonile();
  chiusureGentili();
  preparaFinestra();
  preparaPannello('dettagli');
  preparaPannello('scatola');

  var forme = document.querySelectorAll('[data-affido-form]');
  for (var i = 0; i < forme.length; i++) {
    preparaForm(forme[i]);
    preparaBarra(forme[i]);
  }
})();
